import React from 'react';
import T from 'prop-types';

import { addDays, today } from '../../../../../utils/date';
import SingleDatePicker from '../../../../SingleDatePicker';

const EndDatePicker = ({ value, onChange }) => {
  const maxPeriod = 1460; // 4 years
  const maxDate = addDays(today(), maxPeriod - 1);

  return (
    <SingleDatePicker
      maxPeriod={maxPeriod}
      maxDate={maxDate}
      inputValue={value}
      withCalendarIcon
      unlimitedPeriod
      invokeDateChangeOnValidInput
      onDateChange={onChange}
    />
  );
};

EndDatePicker.propTypes = {
  value: T.string.isRequired,
  onChange: T.func.isRequired,
};

export default EndDatePicker;
